import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ElectronicSignature\StoreSignedElectronicSignatures::__invoke
* @see app/Http/Controllers/ElectronicSignature/StoreSignedElectronicSignatures.php
* @route '/api/electronic-signature/{electronicSignature}/store-signed-electronic-signature/{media_id}'
*/
const StoreSignedElectronicSignatures = (args: { electronicSignature: string | number | { id: string | number }, media_id: string | number } | [electronicSignature: string | number | { id: string | number }, media_id: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: StoreSignedElectronicSignatures.url(args, options),
    method: 'get',
})

StoreSignedElectronicSignatures.definition = {
    methods: ["get","head"],
    url: '/api/electronic-signature/{electronicSignature}/store-signed-electronic-signature/{media_id}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ElectronicSignature\StoreSignedElectronicSignatures::__invoke
* @see app/Http/Controllers/ElectronicSignature/StoreSignedElectronicSignatures.php
* @route '/api/electronic-signature/{electronicSignature}/store-signed-electronic-signature/{media_id}'
*/
StoreSignedElectronicSignatures.url = (args: { electronicSignature: string | number | { id: string | number }, media_id: string | number } | [electronicSignature: string | number | { id: string | number }, media_id: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            electronicSignature: args[0],
            media_id: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        electronicSignature: typeof args.electronicSignature === 'object'
        ? args.electronicSignature.id
        : args.electronicSignature,
        media_id: args.media_id,
    }

    return StoreSignedElectronicSignatures.definition.url
            .replace('{electronicSignature}', parsedArgs.electronicSignature.toString())
            .replace('{media_id}', parsedArgs.media_id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ElectronicSignature\StoreSignedElectronicSignatures::__invoke
* @see app/Http/Controllers/ElectronicSignature/StoreSignedElectronicSignatures.php
* @route '/api/electronic-signature/{electronicSignature}/store-signed-electronic-signature/{media_id}'
*/
StoreSignedElectronicSignatures.get = (args: { electronicSignature: string | number | { id: string | number }, media_id: string | number } | [electronicSignature: string | number | { id: string | number }, media_id: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: StoreSignedElectronicSignatures.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ElectronicSignature\StoreSignedElectronicSignatures::__invoke
* @see app/Http/Controllers/ElectronicSignature/StoreSignedElectronicSignatures.php
* @route '/api/electronic-signature/{electronicSignature}/store-signed-electronic-signature/{media_id}'
*/
StoreSignedElectronicSignatures.head = (args: { electronicSignature: string | number | { id: string | number }, media_id: string | number } | [electronicSignature: string | number | { id: string | number }, media_id: string | number ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: StoreSignedElectronicSignatures.url(args, options),
    method: 'head',
})

export default StoreSignedElectronicSignatures